import React, { useEffect, useState } from "react";
import {
  MDBBadge,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBCol,
  MDBCardFooter,
  MDBBtn,
} from "mdbreact";
import { url } from "api";
import formatTime from "helpers/formatTime";
import { extractImageFromZip } from "helpers/extractImageFromZip";
import DefaultImage from "assets/images/Default_Project_Image.png";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import { modelFileCount } from "helpers/modelVisibility";

const ProjectItemMainAdmin = (props) => {
  const { img, title, description, date, users, _id, timelines, zipInfo, company } =
    props.projectItem;
  const { parentProjectID, isParent } = props;

  const [projectPicture, setProjectPicture] = useState(null);

  const { userWhoCreate } = props;
  const history = useHistory();
  const usersPermissionRedux = useSelector((s) => s.user.userPermission);
  const companyPermissionRedux = useSelector((s) => s.user.companyPermission);
  const allPermissionRedux = useSelector((s) => s.user.allPermission);
  const FinalPermissions = allPermissionRedux
    ?.filter((el) => companyPermissionRedux?.includes(el))
    ?.filter((el) => usersPermissionRedux?.includes(el));
  const canViewAnalytics = FinalPermissions?.includes(ALL_PERMISSIONS.ANALYTICS_VIEW);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      if (img?.split(".").pop() === "gz") {
        const extractedImg = await extractImageFromZip(img);
        if (isMounted) {
          setProjectPicture(extractedImg);
        }
      } else {
        if (isMounted) {
          setProjectPicture(DefaultImage);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [img, props.projectItem]);

  return (
    <MDBCol className={props.className}>
      <MDBCard className="h-100">
        <div className="project-item-img">
          <img
            src={projectPicture}
            alt={`Project ${title}`}
            onError={(e) => (e.target.src = DefaultImage)}
          />
          <span className="project-item-date">{formatTime(date)}</span>
        </div>
        <MDBCardBody>
          <MDBCardTitle className="font-size-2">{title}</MDBCardTitle>
          <MDBCardText
            tag="div"
            className="d-flex flex-column align-items-start"
          >
            <p>{description}</p>
            {users.length === 0 ? (
              <h6>
                <MDBBadge pill tag="span" color="danger">
                  Deleted
                </MDBBadge>
              </h6>
            ) : null}
            <span>
              User: {userWhoCreate?.name} {userWhoCreate?.lastName}
            </span>
            <span>Email: {userWhoCreate?.email}</span>
            {/* A TRANSFER THAT CAN STILL BE PUT BACK (2026-10-15). Only
                passed by the super admin's company page, and only while the
                server says the undo is possible. The label names where the
                project RETURNS TO - the undo API's company is that one. */}
            {props.transferUndo && props.onUndoTransfer ? (
              <span style={{ marginTop: 6, fontSize: 12.5 }}>
                Transferred from {props.transferUndo.backTo.name}
                {" - "}
                <button
                  type="button"
                  className="btn btn-link p-0"
                  style={{ fontSize: 12.5, verticalAlign: "baseline", textTransform: "none" }}
                  onClick={() => props.onUndoTransfer(props.transferUndo)}
                >
                  Undo transfer - return to {props.transferUndo.backTo.name}
                </button>
              </span>
            ) : null}
          </MDBCardText>
        </MDBCardBody>
        <MDBCardFooter className="pl-2 pr-2 pb-2 pt-0">
          <div className="d-flex align-items-center  justify-content-between">
            <MDBBtn
              color=""
              className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit"
              onClick={() => {
                props.openMembersModal();
              }}
            >
              Members
            </MDBBtn>

            {/* MOVING THE PROJECT TO ANOTHER TENANT. Only rendered where a
                handler was passed - this component is used on pages that
                are not the super admin's, and a button that is only
                sometimes authorised is a button that should only sometimes
                exist. */}
            {props.onTransfer && (
              <MDBBtn
                color=""
                className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit"
                onClick={() => {
                  props.onTransfer();
                }}
              >
                Transfer
              </MDBBtn>
            )}

            {isParent && (
              <MDBBtn
                color=""
                className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
                onClick={() => {
                  history.push(`/personal-area/projects/${_id}/timelines`);
                }}
              >
                Projects
              </MDBBtn>
            )}

            <MDBBtn
              color=""
              className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
              onClick={() => {
                // if (!isParent && parentProjectID != "") {
                //   history.push(`../${_id}`);
                // } else {
                //   history.push(`./personal-area/projects/${_id}/timelines`);
                // }
                history.push(`/personal-area/projects/${_id}/timelines`);
              }}
            >
              History ({timelines?.length})
            </MDBBtn>

            {modelFileCount(zipInfo) > 0 && (
              <MDBBtn
                color=""
                className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
                onClick={() => {
                  history.push(`/main-admin/projects/${company}/model-view/${_id}`);
                }}
              >
                Model
              </MDBBtn>
            )}
            <MDBBtn
              color=""
              className="bg-white btnFlex text-bid border-bid shadow-none text-style-inherit"
              onClick={() => history.push(`/exports/history/${_id}`)}
              title="Export history"
            >
              Exports
            </MDBBtn>
            {canViewAnalytics && (
              <MDBBtn
                color=""
                className="bg-white btnFlex text-bid border-bid shadow-none text-style-inherit"
                onClick={() => history.push(`/analytics/project/${_id}`)}
                title="Project analytics"
              >
                Analytics
              </MDBBtn>
            )}
          </div>
        </MDBCardFooter>
      </MDBCard>
    </MDBCol>
  );
};

export default ProjectItemMainAdmin;
